import Spinner from '../../../components/presentational/spinner';

const page = () => {
  return (
    <div className="container">
      <div className="au-flex au-h-half-screen au-justify-center au-items-center au-bg-[#161616]">
        <Spinner className="au-text-white" />
      </div>
    </div>
  );
};

export default page;
